import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// NOTE: We intentionally do NOT set `axios.defaults.withCredentials = true` here.
// The production reverse proxy returns `Access-Control-Allow-Origin: *`, which is
// incompatible with credentialed requests per the CORS spec. Only admin endpoints
// need to send auth cookies — those calls opt in via the `adminApi` axios instance
// in `src/lib/adminApi.js`.

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import LegislativePage from "@/pages/LegislativePage";
import DonatePage from "@/pages/DonatePage";
import DonateSuccessPage from "@/pages/DonateSuccessPage";
import MembersPage from "@/pages/MembersPage";
import EventsPage from "@/pages/EventsPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import NewsPage from "@/pages/NewsPage";
import ResourcesPage from "@/pages/ResourcesPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ForgotPasswordPage from "@/pages/admin/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/admin/ResetPasswordPage";

// Layout
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Routes>
          {/* Admin Routes - No Navbar/Footer */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
          
          {/* Public Routes - With Navbar/Footer */}
          <Route path="/*" element={
            <>
              <Navbar />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/legislative-victories" element={<LegislativePage />} />
                  <Route path="/donate" element={<DonatePage />} />
                  <Route path="/donate/success" element={<DonateSuccessPage />} />
                  <Route path="/members" element={<MembersPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/gallery" element={<GalleryPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/news" element={<NewsPage />} />
                  <Route path="/resources" element={<ResourcesPage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
